<template>
  <v-form v-model="validForm">
    <v-card>
      <v-card-title>
        <span class="headline" v-text="model.id ? `Update ${title}` : `Add ${title}`"></span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md py-0>
          <v-layout wrap>
              <v-form-field v-for="(field, fieldIndex) in fields" 
                :type="field.type" 
                :rules="field.rules" 
                :counter="field.counter" 
                :label="field.label"
                :required="field.required"
                :readonly="field.readonly"
                :disabled="field.disabled"
                :key="fieldIndex"
                v-model="model[field.model]"
              />
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat :disabled="processing" @click.native="onCancel">Cancel</v-btn>
        <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="model.id ? update() : save()" v-text="model.id ? 'Update' : 'Save'"></v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

  import DynamicFormField from "./DynamicFormField"

  export default {
    name: 'DynamicForm',
    props: {
      schema: {
        type: Object,
        required: true
      },
      onSave: Function,
      onUpdate: Function,
      onCancel: Function
    },

    data () {
      return {
      	validForm: false,
        processing: false,
        model: this.schema.model,
        title: this.schema.label,
        apiPath: this.schema.apiPath || this.schema.name.toLowerCase()
      }
    },

    created () {
      	
    },

    methods: {

      save () {
        this.processing = true
        this.axios.post(this.apiPath, this.model)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = this.extend(this.model)
              new_item.id = response.data.data.id

              this.notifySuccess('insertSuccess')
              this.$emit('success', new_item)
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      update () {
        this.processing = true
        this.axios.put(`${this.apiPath}/${this.model.id}`, this.model)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('updateSuccess')
              this.$emit('success', this.model)
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      }
    },

    mounted () {
    	
    },

    computed: {

      fields () {
        let fields = []       
        let entries = Object.entries(this.schema.fields)
        
        if (entries.length) {
          for(const [key, val] of entries){
            if (val.changeable !== false) {
              val.model = key
              fields.push(val)
            }
          }
        }
        return fields
      }
    },

    components: {
      'v-form-field': DynamicFormField
    }

  }
</script>
